import { combineReducers } from 'redux';
import { ACTIONS } from '../constants';

const input = (filter: string) => {
  const value = (state: string = '', action: Object) => {
    if (filter !== action.filter) {
      return state;
    }
    switch (action.type) {
      case ACTIONS.VALID_INPUT:
      case ACTIONS.INVALID_INPUT:
        return action.value;
      case ACTIONS.RESET_INPUT:
        return '';
      default:
        return state;
    }
  };

  const error = (state: any = null, action: Object) => {
    if (filter !== action.filter) {
      return state;
    }
    switch (action.type) {
      case ACTIONS.RESET_INPUT:
      case ACTIONS.VALID_INPUT:
        return null;
      case ACTIONS.INVALID_INPUT:
        return action.error;
      default:
        return state;
    }
  };

  const isValid = (state: boolean = false, action: Object) => {
    if (filter !== action.filter) {
      return state;
    }
    switch (action.type) {
      case ACTIONS.VALID_INPUT:
        return true;
      case ACTIONS.RESET_INPUT:
      case ACTIONS.INVALID_INPUT:
        return false;
      default:
        return state;
    }
  };

  return combineReducers({
    value,
    error,
    isValid,
  });
};

export default input;

export const getInputValue = (state: Object) => (state ? state.value : null);
export const getInputError = (state: Object) => (state ? state.error : null);
export const getIsValidInput = (state: Object) =>
  state ? state.isValid : null;
